(function() { module.exports = this["wp"]["blocks"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","blocks"]}
// module id = 1
// module chunks = 0